import { ChangeEvent, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faUser } from '@fortawesome/pro-light-svg-icons'

import {
  FormField, InputSearch, Link, SidebarModal, UserProfileImage,
} from '@domain-group/suit-theme'

import type { BulkShareArtworksPayload } from '@hooks/useBulkShareArtworks'

// @ts-expect-error TS7006
const mapResults = (contacts) => {
  const results = {
    groups: [
      {
        key: 'agency',
        title: 'AGENCY',
        items: contacts
          // @ts-expect-error TS7006
          .filter(c => c.type !== 'Contact')
          // @ts-expect-error TS7006
          .map((contact) => {
            const image = contact.image || {}
            return {
              ...contact,
              iconLeft: (
                <UserProfileImage imageUrl={image.square}>
                  <FontAwesomeIcon icon={faUser} />
                </UserProfileImage>
              ),
              text: contact.full_name,
              secondaryText: contact.email || 'No Email',
              key: `User-${contact.id}`,
            }
          }),
      },
    ],
  }

  return results
}

interface EmailDetailsProps {
  bulkShareArtworksPayload: BulkShareArtworksPayload,
}

const EmailDetails = (props: EmailDetailsProps) => {
  const {
    bulkShareArtworksPayload: {
      callbacks: { selectUserId, setState },
      contacts,
      entities: { images },
      hasSelectedUsers,
      message,
      selectedUsers,
      subject,
    },
  } = props

  const [filterString, setFilterString] = useState('')

  return (
    <>
      <FormField
        direction="column"
        label="Add Recipients"
        marginTop="large"
        style={{ zIndex: 1 }}
      >
        <InputSearch
          callbacks={{ selectItem: item => selectUserId(item.id) }}
          closeOnSelect
          onChange={(e: ChangeEvent<HTMLInputElement>) => setFilterString(e.target.value)}
          placeholder="Search for users"
          results={mapResults(contacts)}
          showOnFocus
          value={filterString}
        />
      </FormField>

      {hasSelectedUsers && (
        <>
          <FormField direction="column" label="Selected Recipients" marginTop="large">
            {selectedUsers.map((user) => {
              const { id, full_name, email } = user
              // @ts-expect-error TS2339
              const image = images[user.image] || {}

              return (
                <SidebarModal.User
                  disableHover
                  imageUrl={image.square_url || null}
                  key={id}
                  title={full_name}
                  subtitle={email || 'No Email'}
                >
                  <Link greyLink onClick={() => selectUserId(user.id)} textProps={{ fontSize: 'small' }}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </Link>
                </SidebarModal.User>
              )
            })}
          </FormField>

          <FormField direction="column" label="Subject" marginTop="large">
            <input
              onChange={e => setState({ subject: e.target.value })}
              type="text"
              value={subject}
            />
          </FormField>

          <FormField direction="column" label="Message" marginTop="large">
            <textarea
              onChange={e => setState({ message: e.target.value })}
              style={{ height: 80 }}
              value={message}
            />
          </FormField>
        </>
      )}
    </>
  )
}

export default EmailDetails
